import React from "react";
import SnackbarContext from "./SnackbarContext";
import Snackbar from "./Snackbar";

export default function SnackbarProvider({ children }) {
  const [state, setState] = React.useState({});

  /**
   * Display a message with this snackbar.
   * @param {string} text message to display
   * @param {object} snackbarProps object with Karsten Snackbar props
   * @public
   */
  const showMessage = (text, snackbarProps) => {
    setState({ open: true, text, ...snackbarProps });
  };

  const closeMessage = () => {
    setState({ open: false, text: "", snackbarProps: state.snackbarProps });
  };

  return (
    <>
      <SnackbarContext.Provider value={{ showMessage, closeMessage }}>
        {children}
      </SnackbarContext.Provider>
      <Snackbar
        {...state}
        open={state.open && state.text?.length > 0}
        onClose={closeMessage}
      />
    </>
  );
}
